export default "__VITE_ASSET__D4P4pcIZ__"